/**
 * custom.js — 2026-09-07 round 4: rewritten without jQuery (behaviour preserved 1:1).
 * Globals used from the theme: show_progress_bar, routes, parser, updateCartDrawer, shippingProductId.
 */
(function () {
  var dclFired = false;
  document.addEventListener('DOMContentLoaded', function () { dclFired = true; });
  function ready(fn) {
    if (document.readyState === 'complete' || dclFired) { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function delegate(root, type, sel, fn) {
    root.addEventListener(type, function (e) {
      var t = e.target && e.target.closest ? e.target.closest(sel) : null;
      if (t && root.contains(t)) { fn.call(t, e); }
    });
  }
  function hiddenInput(name, value) {
    var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = name; inp.value = value; return inp;
  }

  ready(function () {
    var thresholdEl = document.querySelector('[data-treshold-product]');
    var amountFreeProduct = thresholdEl ? thresholdEl.getAttribute('data-treshold-product') : null;
    var totalEl = document.querySelector('.gb-totals-total-value');
    var cart_total = totalEl ? totalEl.textContent : '';

    if (amountFreeProduct > 0 && window.show_progress_bar) {
      var hasPremiumKit = document.querySelector('.premium-attachment-kit') !== null;
      if (hasPremiumKit) {
        console.log('Premium kit detected - skipping auto free gift trigger');
      } else {
        /*GB! free product added STARTS*/
        setTimeout(function () {
          var el = document.querySelector('.gb-totals-total-value');
          var cart_total = el ? el.textContent : '';
          if (cart_total >= amountFreeProduct) {
            if (document.querySelector('.cart-item.gb-find-remove-product')) {
              console.log('Free product already in cart');
            } else {
              console.log('Adding free product');
              $$('.gb-free-product-trigger').forEach(function (b) { b.click(); });
            }
          } else {
            console.log('Removing free product - under threshold');
            $$('.gb-remove-product').forEach(function (b) { b.click(); });
          }
        }, 3000);
        delegate(document.body, 'click', '.gb-sumbit-free', function () {
          setTimeout(function () {
            if (cart_total >= amountFreeProduct) {
              if (!document.querySelector('.cart-item.gb-find-remove-product')) {
                $$('.gb-free-product-trigger').forEach(function (b) { b.click(); });
              }
            } else {
              $$('.gb-remove-product').forEach(function (b) { b.click(); });
            }
          }, 3000);
        });
      }
    }

    delegate(document.body, 'click', '.gb-shipping-protection-button label.switch', async function (e) {
      if (e.target.tagName == 'INPUT') return;
      var curElem = document.querySelector('.gb-shipping-protection-button label.switch');
      var curInputElem = document.querySelector('.gb-shipping-protection-button label.switch input');
      var spinAnim = document.querySelector('.gb-shipping-protection-button .spin-animation');
      var checkElem = document.querySelector('.gb-shipping-protection-button .complete-check');
      var wasChecked = curElem.classList.contains('checked');

      if (!wasChecked) {
        if (spinAnim.style.display == 'block' || curInputElem.checked) return;
        var form = document.querySelector('form.shipping-protection-form');
        var formData = new FormData(form);
        if (!formData.get('id')) {
          console.error('There is no shipping protection product selected. Please select the shipping product in the global theme settings');
          return;
        }
        spinAnim.style.display = 'block';
        try {
          var response = await fetch(routes.cart_add_url, { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
          if (response.ok) { spinAnim.style.display = 'none'; checkElem.style.display = 'block'; }
        } catch (err) {
          console.error('error at shipping protection form submission', err);
        }
        fetch(routes.cart_url + '?view=drawer')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var cartDrawer = document.querySelector('#CartDrawer');
            var parsedCartHtml = parser.parseFromString(html, 'text/html');
            var newCartDrawer = parsedCartHtml.querySelector('#CartDrawer');
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, function () {
                curElem.classList.remove('unchecked'); curElem.classList.add('checked'); curInputElem.checked = true;
              });
            }
          })
          .catch(function () { curElem.classList.remove('unchecked'); curElem.classList.add('checked'); curInputElem.checked = true; });
      } else {
        checkElem.style.display = 'none';
        var cartDrawer = document.querySelector('#CartDrawer');
        var removeButton = cartDrawer.querySelector('cart-remove-button[data-id="' + shippingProductId + '"]');
        var shippingItemIndex = removeButton && removeButton.dataset.index;
        var removeCallback = function () { curElem.classList.remove('checked'); curElem.classList.add('unchecked'); curInputElem.checked = false; };
        var cartItems = cartDrawer.querySelector('cart-items') || cartDrawer.querySelector('cart-drawer-items');
        if (removeButton && shippingItemIndex && cartItems && cartItems.updateQuantity) {
          var event = new CustomEvent('remove-shipping-protection', { detail: null });
          cartItems.updateQuantity(shippingItemIndex, 0, event, '', '', removeCallback);
        } else {
          fetch(routes.cart_change_url, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: shippingProductId, quantity: 0 }) })
            .then(function () { return fetch(routes.cart_url + '?view=drawer'); })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var cd = document.querySelector('#CartDrawer');
              var parsed = parser.parseFromString(html, 'text/html');
              var ncd = parsed.querySelector('#CartDrawer');
              if (cd && ncd) { updateCartDrawer(cd, ncd, true, removeCallback); } else { removeCallback(); }
            })
            .catch(function () { removeCallback(); });
        }
      }
    });

    delegate(document.body, 'change', '.gb-change-variant_id', function () {
      var opt = this.options ? this.options[this.selectedIndex] : null;
      var id_change = opt ? opt.getAttribute('data-variant-id') : null;
      if (!id_change) { console.error('No data-variant-id found on selected option'); return; }
      var block = this.closest('.gb-get-main-freq-pro');
      if (block) { $$('.product-variant-id', block).forEach(function (i) { i.value = id_change; }); }
    });
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('.cart-drawer .gbfrequently-bought-with-main-whole .select__select')) {
      var parentBlock = e.target.closest('.gb-get-main-freq-pro');
      if (!parentBlock) { console.log('Error: Could not find parent block'); return; }
      var allValues = Array.from(parentBlock.querySelectorAll('.select__select')).map(function (sel) { return sel.value; }).join(' / ');
      var variantSelect = parentBlock.querySelector('[name="variants"]');
      if (!variantSelect) { console.log('Error: Could not find variant selector'); return; }
      var matchedOption = Array.from(variantSelect.options).find(function (option) { return option.text.includes(allValues); });
      var idInput = parentBlock.querySelector('[name="id"]');
      if (!idInput) { console.log('Error: Could not find id input field'); return; }
      if (matchedOption) {
        console.log('Matched variant option value:', matchedOption.value);
        idInput.value = matchedOption.value;
        console.log('Set ID input value to:', idInput.value);
      } else {
        console.log('No matching variant found for:', allValues);
      }
    }
  });

  // Add validation for form submissions to ensure ID parameter is present
  document.addEventListener('submit', function (e) {
    if (e.target.action && e.target.action.includes('/cart/add')) {
      var idInput = e.target.querySelector('[name="id"]');
      if (!idInput || !idInput.value) {
        console.log('Preventing submission - missing id parameter');
        e.preventDefault();
        return false;
      }
    }
  });

  // Improve cart quantity handlers
  ready(function () {
    function ensureId() {
      var form = this.closest('form');
      var qi = this.closest('.quantity-input');
      var qInput = qi ? qi.querySelector('.quantity__input') : null;
      var variantId = qInput ? qInput.dataset.quantityVariantId : undefined;
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (!idInput && variantId) {
          console.log('Adding missing ID input to cart form');
          form.appendChild(hiddenInput('id', variantId));
        } else if (idInput && variantId) {
          idInput.value = variantId;
        }
      }
    }
    $$('.cart-item .quantity__button, .cart-item .quantity__input').forEach(function (el) {
      ['click', 'change', 'input'].forEach(function (t) { el.addEventListener(t, ensureId); });
    });

    var checkout = document.getElementById('CartDrawer-Checkout');
    if (checkout) {
      checkout.addEventListener('click', function (e) {
        var form = document.getElementById('CartDrawer-Form');
        if (!form) return;
        var cartItems = form.querySelectorAll('.cart-item');
        if (cartItems.length === 0) {
          console.log('No items in cart, preventing checkout');
          e.preventDefault();
          return false;
        }
        console.log('Cart checkout with', cartItems.length, 'items');
      });
    }

    /** Prevent redirecting to checkout when pressing enter at quantity input */
    delegate(document, 'keydown', '.quantity__input', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); this.blur(); }
    });
  });

  // Fix for frequently bought products add to cart
  ready(function () {
    $$('.gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-trigger, .gb-product-shipping-protection-product-tirgger, .gb-product-sticky-add-to-cart-form').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var parentBlock = this.closest('.gb-get-main-freq-pro, form');
        if (!parentBlock) { console.error('Could not find parent block for frequently bought product'); return; }
        var productId = null;
        var idInput = parentBlock.querySelector('input[name="id"]');
        var variantSel = parentBlock.querySelector('.gb-change-variant_id');
        var pvId = parentBlock.querySelector('.product-variant-id');
        if (idInput && idInput.value) {
          productId = idInput.value;
        } else if (variantSel) {
          var selectedOption = variantSel.options[variantSel.selectedIndex];
          if (selectedOption) { productId = selectedOption.dataset.variantId; }
        } else if (pvId) {
          productId = pvId.value;
        } else if (this.dataset.variantId) {
          productId = this.dataset.variantId;
        }
        console.log('Frequently bought product add to cart - ID:', productId);
        if (this.classList.contains('gb-free-product-trigger') && !window.show_progress_bar) return;
        if (!productId) {
          console.error('Missing product ID for frequently bought product');
          e.preventDefault();
          return false;
        }
        if (!idInput) {
          console.log('Adding missing ID input to frequently bought product form');
          parentBlock.appendChild(hiddenInput('id', productId));
        } else {
          idInput.value = productId;
        }
        var quantityInput = parentBlock.querySelector('input[name="quantity"]');
        if (!quantityInput) {
          console.log('Adding default quantity input to frequently bought product form');
          parentBlock.appendChild(hiddenInput('quantity', 1));
        } else if (!quantityInput.value || quantityInput.value < 1) {
          quantityInput.value = 1;
        }
      });
    });
  });
})();
